<template>
	<div class="show-more">
		<div v-if="$slots.primary">
			<slot name="primary"></slot>
		</div>
		<div v-if="$slots.secondary">
			<div
				v-if="!isExpanded"
				@click="toggleExpansion"
			>
				<slot name="more" :toggle="toggleExpansion">
					<div class="show-more__button">
						<TeamingButton2
							size="TINY"
							type="TERTIARY"
						>{{ translate( `moreLabel` ) }}</TeamingButton2>
					</div>
				</slot>
			</div>
			<slot name="secondary" v-if="isExpanded"></slot>
			<div
				v-if="isExpanded"
				@click="toggleExpansion"
			>
				<slot name="fewer" :toggle="toggleExpansion">
					<div class="show-more__button">
						<TeamingButton2
							size="TINY"
							type="TERTIARY"
						>{{ translate( `fewerLabel` ) }}</TeamingButton2>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
import TranslateMixin from "../mixins/TranslateMixin";
import TeamingButton2 from "./buttons/TeamingButton2.vue";

export default {
	name: "ShowMore",
	teamingPackage: "common-ui",
	mixins: [ TranslateMixin, ],
	events: [ "expand", "collapse", ],
	components: {
		TeamingButton2,
	},
	data() {
		return {
			isExpanded: false,
		};
	},
	methods: {
		toggleExpansion() {
			this.isExpanded = !this.isExpanded;
			if ( this.isExpanded ) {
				this.$emit( "expand" );
			} else {
				this.$emit( "collapse" );
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.show-more__button {
	display: flex;
	justify-content: flex-start;
}
</style>
